import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContextUpdatesService } from 'src/app/services/context-updates.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';

@Component({
  selector: 'app-project-card-item',
  templateUrl: './project-card-item.component.html',
  styleUrls: ['./project-card-item.component.scss'],
})
export class ProjectCardItemComponent {
  @Input() project;

  constructor(
    private router: Router,
    private contextUpdatesService: ContextUpdatesService,
  ) {}

  getLastModifiedValue(project) {
    return JSON.stringify({
      user: null,
      label: project?.lastModifiedDate,
      emptyStateLabelText: 'Not available',
    });
  }

  onCardClick() {
    triggerAnalyticsEvent(`PROJECTS_PROJECT_SELECT_PROJECT`, {
      projectName: this.project?.name,
    });
    let branch = this.contextUpdatesService.getLastBranchForBlueprint(
      this.project?.name,
    );
    if (!branch) {
      branch = this.project?.branch;
      this.contextUpdatesService.setLastOpenedBranchInLocalStorage(
        this.project?.name,
        branch,
      );
    }
    const url =
      '/stack/' +
      this.project?.name +
      '/blueprint-designer/' +
      branch +
      '/resource-list';
    this.router.navigate([url]).catch((err) => {
      console.error('project card navigation error', err);
    });
  }

  handleGitIconClick(event, project) {
    event.stopPropagation(); // Prevents the click event from propagating to the card
    if (project.gitOpsEnabled) {
      triggerAnalyticsEvent('PROJECT_PROJECT_GITHUB_REDIRECT');
      window.open(project?.vcsUrl);
    } else {
      triggerAnalyticsEvent('PROJECT_PROJECT_GITOPS_REDIRECT');
      this.router.navigate(['stack', this.project.name, 'project-settings'], {
        state: {
          activeId: 'gitops',
        },
      });
    }
  }
}
